export type BonusIcon = 'timer' | 'message' | 'users' | 'flame' | 'lightbulb'

export interface Bonus {
  number: string
  title: string
  tagline: string
  /** Label color from the bonus covers in the mockup. */
  color: string
  /** Placeholder icon shown until a cover image is added. */
  icon: BonusIcon
  /** Cover image URL — add one per bonus when ready. */
  image?: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '5-Minute Session Builder™',
    tagline:
      'Answer 6 key questions and get a clear session structure in minutes.',
    color: '#16a34a',
    icon: 'timer',
    image:
      'https://cdn.magicpatterns.com/uploads/j2fuy87gcGfnZjm1Jvf9A1/bo1_(1).webp',
  },
  {
    number: '2',
    title: 'Coaching Cues Library™',
    tagline:
      'Short cues for every skill. Less talking, clearer corrections, more reps.',
    color: '#2563eb',
    icon: 'message',
    image:
      'https://cdn.magicpatterns.com/uploads/xykrpapAEaNjVGRHTvdjNQ/bo2_(1).webp',
  },
  {
    number: '3',
    title: 'Mixed-Level Adaptation Kit™',
    tagline:
      'Turn one exercise into multiple levels: easier, harder, faster or more pressured.',
    color: '#ea580c',
    icon: 'users',
    image:
      'https://cdn.magicpatterns.com/uploads/hyN9jSar8j1ZdBo42jXCSR/bo3_(1).webp',
  },
  {
    number: '4',
    title: 'Ready-to-Run Warm-Ups™',
    tagline: 'Structured warm-ups so every session starts with purpose.',
    color: '#dc2626',
    icon: 'flame',
    image:
      'https://cdn.magicpatterns.com/uploads/99mLdhRjkb97VX1BFJvW5V/bo4_(1).webp',
  },
  {
    number: '5',
    title: 'Drill Fixer™',
    tagline:
      'Quick fixes when a drill is not working. Change one variable at a time.',
    color: '#7c3aed',
    icon: 'lightbulb',
    image:
      'https://cdn.magicpatterns.com/uploads/mGVavVEg2wnzDvdPhjKirh/bo5_(1).webp',
  },
]
